import type { Node } from 'reactflow';

const CLS = 'chatmap-director-spotlight';

/**
 * TH-3b — add a steady spotlight ring class to the framed exchange cluster
 * (match by data.turnKey ∈ set). Twin of decorateGreetingFlash; pure. A null
 * set returns the input array by reference (RF11 identity fast-path survives).
 * Ring is a CSS class only — never style.transform (fights RF's pan/zoom).
 */
export function decorateDirectorSpotlight(nodes: Node[], spotlightTurnKeys: ReadonlySet<string> | null): Node[] {
  if (!spotlightTurnKeys) return nodes;
  return nodes.map((n) => {
    const lit = spotlightTurnKeys.has((n.data as any)?.turnKey ?? '');
    const base = (n.className ?? '').replace(CLS, '').trim();
    return { ...n, className: lit ? `${base} ${CLS}`.trim() : base };
  });
}
